import CloseIcon from '@mui/icons-material/Close';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { Box, Grid, IconButton, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { PopupComponent } from 'src/components/common/PopupComponent';
import { openCRFModel } from 'src/store/CrfFormsAction';
import { useAppDispatch, useAppSelector } from 'src/store/hooks';
import CRFFormModal from './CRFFormModal';
import CRFVisitEventsMenu from './CRFVisitEventsMenu';

const CRFBasePopup = ({
  selectedCRFFormCode,
  crfFormMetaData,
  parent_id,
  isUpdate,
  setisUpdate,
  selectedVisit,
  visitsData,
  editRowData,
  setselectedVisit,
  seteditRowData,
  bookMarkKey,
  getPatientsDetailsData,
  subject_id,
  bookMarkField,
  eventDataLoading
}: any) => {
  const dispatch = useAppDispatch();
  const isOpenCRFModel = useAppSelector(state => state.CRFForms.isOpenCRFModel);
  const selectedCRFRow = useAppSelector(state => state.CRFForms.selectedCRFRow);
  const [open, setOpen] = useState(false);

  const handleClose = () => {
    dispatch(openCRFModel(false));
    setisUpdate(false);
    setisUpdate(false);
    setselectedVisit(null);
    seteditRowData(null);
  };
  useEffect(() => {
    setOpen(isOpenCRFModel);
  }, [isOpenCRFModel]);

  const [modifiedFormConfig, setmodifiedFormConfig] = useState<any>();

  const didsetmodifiedFormConfig = (result: any) => {
    setmodifiedFormConfig(result);
  };

  useEffect(() => {
    didsetmodifiedFormConfig(crfFormMetaData);
  }, [crfFormMetaData]);
  return (
    <div>
      <PopupComponent fullScreen open={open} onClose={handleClose} style={{ margin: '15px' }}>
        <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div" />
        <IconButton
          edge="start"
          color="inherit"
          onClick={handleClose}
          aria-label="close"
          sx={{ position: 'absolute', right: 0, zIndex: 12 }}
        >
          <CloseIcon />
        </IconButton>

        <Grid container spacing={3} mt={0} sx={{ height: '100%' }}>
          <Grid item xs={2} sx={{ borderRight: '1px solid #ccc' }}>
            <Box display={'flex'} justifyContent={'space-between'} alignContent={'center'} pl={2} mb={2}>
              <Typography variant="h6">
                {selectedVisit?.visit_crf?.custom_name ?? selectedVisit?.visit_crf?.meta?.title}
              </Typography>
              <IconButton sx={{ mt: -0.5 }}>
                <MoreVertIcon />
              </IconButton>
            </Box>
            <CRFVisitEventsMenu
              visitsData={visitsData}
              bookMarkKey={bookMarkKey}
              setselectedVisit={setselectedVisit}
              selectedVisit={selectedVisit}
              modifiedFormConfig={modifiedFormConfig}
              setmodifiedFormConfig={didsetmodifiedFormConfig}
              seteditRowData={seteditRowData}
              editRowData={editRowData}
              bookMarkField={bookMarkField}
            />
          </Grid>
          <Grid item xs={10} display={'flex'}>
            {modifiedFormConfig ? (
              <CRFFormModal
                handleCloseModel={handleClose}
                selectedCRFRow={selectedCRFRow}
                formConfig={modifiedFormConfig}
                selectedCRFFormCode={selectedCRFFormCode}
                parent_id={parent_id}
                subject_id={subject_id}
                isUpdate={isUpdate}
                setisUpdate={setisUpdate}
                selectedVisit={selectedVisit}
                visitsData={visitsData}
                editRowData={editRowData}
                setselectedVisit={setselectedVisit}
                seteditRowData={seteditRowData}
                bookMarkKey={bookMarkKey}
                getPatientsDetailsData={getPatientsDetailsData}
                bookMarkField={bookMarkField}
                eventDataLoading={eventDataLoading}
              />
            ) : null}
          </Grid>
        </Grid>
      </PopupComponent>
    </div>
  );
};
export default CRFBasePopup;
